import React, { Component, Fragment } from "react";
import Breadcrumbs from "../../../utilities/breadcrumbs";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import i18n from "../../../../i18n";
import Select2 from "../../../utilities/Form/Select2";
import DatePickerCustom from "../../../utilities/Form/datepicker";
import { Button, Table } from "react-bootstrap";
import cookieManager from "../../../../utils/cookieManager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import SalesInvoiceReportMiddleware from "../../../../middleware/modules/report/sales-report";
import DataListRequest from "./list-request";
import DataListFull from "./list-full";
import TrackingSalesMiddleware from "../../../../middleware/modules/report/tracking-sales";
const MySwal = withReactContent(Swal);
export class TrackingSales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [
        { link: process.env.APP_URL, title: i18n.t("Home"), class: " text-gray-600" },
        { link: null, title: i18n.t("Report"), class: " text-gray-600" },
        { link: null, title: i18n.t("Tracking Sales"), class: " text-gray-500" },
      ],
      idSupplier: null,
      supplierList: [],
      supplierText: 'All',
      supplierCurrent: null,
      idBranch: null,
      branchCurrent: null,
      branchText: i18n.t("Select Branch"),
      branchList: [],
      loadingStore: false,
      loadingCustomer: false,
      idStore: null,
      storeCurrent: null,
      storeText: i18n.t("Select Store"),
      storeList: [],
      idCustomer: null,
      customerCurrent: null,
      customerText: i18n.t("All"),
      customerList: [],
      date: new Date(),
      startDate: new Date(),
      endDate: new Date(),
      progressConvert: false,
      showData: false,
      showDataDetail: false,
      transactionList: null,
      orderList: null,
      loadingData: false,
      loadingDataDetail: false,
      idSO: null,
    }
    this.handlerSelect = this.handlerSelect.bind(this);
    this.handlerDateTime = this.handlerDateTime.bind(this);
    this.updateShow = this.updateShow.bind(this);
    this.backPage = this.backPage.bind(this);
    this.updateShowDetail = this.updateShowDetail.bind(this);
  }
  renderError(name) {
    const { isError, errorMessage } = this.props;
    var value = "";
    if (isError) {
      if (errorMessage[name] != undefined) {
        value = errorMessage[name][0];
      }
    }
    return i18n.t(value);
  }
  handlerSelect(e, name, currentState) {
    var key = name;
    var value = null;
    if (e != null) {
      value = e.value;
    }
    this.setState({
      [key]: value,
      [currentState]: e,
    }
    );
  }

  updateShow(newShow, id) {
    this.setState({ showDataDetail: newShow, showData: false, idSO: id, loadingData: true }, () => this.getDataDetail('getTransaction'));
  }

  backPage(back) {
    this.setState({ showDataDetail: false, showData: back });
  }

  updateShowDetail(newShow, id) {
    this.setState({ showDataDetail: newShow, idPO: id, loadingDataDetail: true }, () => this.getDataDetail('getOrder'));
  }
  getDataDetail(type, extra = () => { }) {
    const token = cookieManager.getUserToken();
    let params = null;
    let fill = null;
    let method = null;
    switch (type) {
      case "getTransaction":
        fill = "transactionList";
        method = "POST";
        var url = process.env.REST_URL + 'report/tracking-sales-full';
        var idSO = this.state.idSO != undefined
          ? this.state.idSO
          : null;
        params = {
          idSO: idSO,
        }


        break;
      case "getOrder":
        fill = "orderList";
        method = "POST";
        var url = process.env.REST_URL + 'report/tracking-purchasing-po';
        var branch =
          this.state.branchCurrent != undefined
            ? this.state.branchCurrent.value
            : null;
        var supplier = this.state.idSupplier != undefined
          ? this.state.idSupplier
          : null;
        var po = this.state.idPO != undefined
          ? this.state.idPO
          : null;
        var startDate = moment(this.state.startDate).format('YYYY-MM-DD');
        var endDate = moment(this.state.endDate).format('YYYY-MM-DD');

        if (branch != null) {
          params = {
            idBranch: branch,
            idSupplier: supplier,
            startDate: startDate,
            endDate: endDate,
            idPO: po,
          };
        }


        break;
    }

    switch (method) {
      case "POST":
        axios({
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${SalesInvoiceReportMiddleware.getToken()}`
          },
          url: url,
          data: params,
          responseType: 'json'
        })
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              this.setState({ [fill]: response.data.result, loadingData: false, loadingDataDetail: false }, extra);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        break;
      case "GET":
        axios({

          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${TrackingPurchasingMiddleware.getToken()}`
          },
          url: url,
          params: params,
          responseType: 'json'
        })
          .then((response) => {
            if (response && response.status === 200 && response.data) {
              this.setState({ [fill]: response.data.result, loadingData: false, loadingDataDetail: false }, extra);
            }
          })
          .catch((error) => {
            console.log(error);
          });
        break;
    }
  }

  getData(type,extra=()=>{}) {
     const token = cookieManager.getUserToken();
     let params = null;
     let fill = null;
     switch (type) {
       case "getStore":
         fill = "storeList";
         var url = process.env.REST_URL + "helper/get-store";
         var branch =
           this.state.branchCurrent != undefined
             ? this.state.branchCurrent.value
             : null;
         if (branch != null) {
           params = {
             id: branch,
           };
         }
 
         break;
       case "getCustomer":
         fill = "customerList";
         var url = process.env.REST_URL + "helper/get-customer";
         var branch =
           this.state.branchCurrent != undefined
             ? this.state.branchCurrent.value
             : null;
         var store =
           this.state.storeCurrent != undefined
             ? this.state.storeCurrent.value
             : null;
         if (branch != null || store != null) {
           params = {
             branch: branch,
             store: store,
           };
         }
 
         break;
     }
 
     if (type != null && params != null) {
       axios({
         method: "GET",
         headers: {
           "Content-Type": "application/json",
           Authorization: `Bearer ${token}`,
         },
         url: url,
         responseType: "json",
         params: params,
       })
         .then((response) => {
           if (response && response.status === 200 && response.data) {
             this.setState({ [fill]: response.data.result },extra);
           }
         })
         .catch((error) => {
           console.log(error);
         });
     }
   }
  handlerDateTime(e, name) {
    var key = name;
    var value = e
    this.setState({
      [key]: value
    })
  }

  renderLoading() {
    Swal.fire({
      title: 'Loading',
      width: "200px",
      heightAuto: true
    });
    Swal.showLoading();
  }
  alertHandler(title, message, icon) {
    Swal.fire({
      title: title,
      html: message,
      icon: icon,
    });
  }
  async convertExcel() {
    if (this.state.employeeCurrent != null) {
      this.setState({ progressConvert: true })

      const params = {
        date: moment(this.state.date).format('YYYY-MM-DD'),
        idEmployee: this.state.idEmployee,
      }

      var salesName = this.state.employeeCurrent?.label
      var nameFile = 'Report Visiting ' + (moment(this.state.date).format('DD MM YYYY')) + ' Sales ' + salesName;

      this.renderLoading();
      const token = cookieManager.getUserToken();
      axios({
        headers: {
          Authorization: `Bearer ${token}`,
        },
        url: process.env.REST_URL + "sales/report-visit-excel",
        method: "GET",
        params: params,
        responseType: "blob",
      }).then((response) => {
        if (response && response.status === 200 && response.data) {
          Swal.close();
          this.setState({ progressConvert: false })
          this.alertHandler('Convert Excel', 'Download Successfully', 'success')
          var urlCreator = window.URL || window.webkitURL;
          const blobUrl = urlCreator.createObjectURL(response.data);
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = blobUrl;
          link.setAttribute("download",
            nameFile + '.xlsx');
          document.body.appendChild(link);
          link.click();
          link.remove();
        } else {
          Swal.close();
        }
      }).catch((error) => {
        this.setState({ progressConvert: false })
        this.alertHandler('Convert Excel', 'Internal Server Error', 'info')
      });
    }

  }

  showTracking() {
    const post = {
      startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
      endDate: moment(this.state.endDate).format('YYYY-MM-DD'),
      idBranch: this.state.branchCurrent ? this.state.branchCurrent.value : '',
      idStore: this.state.storeCurrent ? this.state.storeCurrent.value : '',
      idCustomer: this.state.customerCurrent ? this.state.customerCurrent.value : '',
    }

    this.props.getTracking(post)
  }

  render() {
    const { helper, isProcessing, dataTracking } = this.props;
    let arr = [];
    if (helper != null && helper != undefined) {
      this.state.branchList = helper.branch;
      this.state.supplierList = helper.supplier;
    }
    if (dataTracking != null && dataTracking != undefined) {
      arr = dataTracking.data;
    }

    return (
      <div id="customer-type">
        <Breadcrumbs url={this.state.breadcrumbs} tools={false} />
        <div
          id="kt_content_container"
          className="d-flex flex-column-fluid align-items-start container-fluid"
        >

          <div className="content flex-row-fluid" id="kt_content">
            <div className="card">
              <div className="card-body pt-3">
                <div className="row mb-4">
                  <div className="col-sm-3">
                    <DatePickerCustom
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      selectsRange={true}
                      isClearable={false}
                      name={"date"}
                      title={i18n.t("Date Period")}
                      required={true}
                      onChange={(e) => {
                        const [start, end] = e;
                        this.setState({ startDate: start, endDate: end });
                      }}
                      la
                      showYearDropdown
                      yearDropdownItemNumber={15}
                      scrollableYearDropdown
                      peekNextMonth
                      showMonthDropdown
                      autoComplete={"off"}
                      dateFormat="dd MMMM yyyy"
                      maxDate={new Date()}
                      className="form-control form-control-md"
                    />
                  </div>
                  <div className="col-sm-3">
                    <Select2
                      isClearable={true}
                      name={"idBranch"}
                      required={true}
                      onChange={async (e) => {
                        if (e != this.state.branchCurrent) {
                          await this.setState({
                            storeList: [],
                            storeCurrent: null,
                            idStore: null,
                            customerList: [],
                            customerCurrent: null,
                            idCustomer: null,
                            loadingStore:true,
                            loadingCustomer:true,
                          });
                          await this.handlerSelect(
                            e,
                            "idBranch",
                            "branchCurrent"
                          );
                          await this.getData("getStore",()=>{
                            this.setState({ loadingStore:false})
                          });
                          await this.getData("getCustomer",()=>{
                            this.setState({ loadingCustomer:false})
                          });
                        }
                      }}
                      options={this.state.branchList}
                      title={i18n.t("Branch")}
                      value={this.state.branchCurrent}
                      currentState={"branchCurrent"}
                      placeholder={this.state.branchText}
                      error={this.renderError("idBranch")}
                    />
                  </div>
                  <div className="col-sm-3">
                    <Select2
                      isClearable={true}
                      isLoading={this.state.loadingStore}
                      name={"idStore"}
                      required={false}
                      onChange={async (e) => {
                        if (e != this.state.storeCurrent) {
                          await this.setState({
                            customerList: [],
                            customerCurrent: null,
                            idCustomer: null,
                            loadingCustomer:true,
                          });
                          await this.handlerSelect(
                            e,
                            "idStore",
                            "storeCurrent"
                          );
                          await this.getData("getCustomer",()=>{
                            this.setState({ loadingCustomer:false})
                          });
                        }
                      }}
                      options={this.state.storeList}
                      title={i18n.t("Store")}
                      value={this.state.storeCurrent}
                      currentState={"storeCurrent"}
                      placeholder={this.state.storeText}
                      error={this.renderError("idStore")}
                    />
                  </div>
                  <div className="col-sm-3">
                    <Select2
                      isClearable={true}
                      name={"idCustomer"}
                      required={true}
                       isLoading={this.state.loadingCustomer}
                      onChange={(e) =>
                        this.handlerSelect(e, "idCustomer", "customerCurrent")
                      }
                      options={this.state.customerList}
                      title={i18n.t("Customer")}
                      value={this.state.customerCurrent}
                      currentState={"customerCurrent"}
                      placeholder={this.state.customerText}
                    />
                  </div>
                  <div className="row">
                    <div className="col-sm-6 d-flex gap-5">
                      <Button
                        onClick={(e) => {
                          this.setState({ showData: true, showDataDetail: false });
                          this.showTracking();
                        }}
                        variant="success"
                        className="btn btn-md btn btn-success mt-8 "
                      >
                        {isProcessing ?
                          <span className="indicator-progress " >{i18n.t("Please wait")}...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                          :
                          <span className="indicator-label"><FontAwesomeIcon icon={faEye}></FontAwesomeIcon> {i18n.t("Show")}</span>
                        }

                      </Button>
                    </div>
                    {/* {this.state.showData && dataTracking? 
                  <div className="col-sm-6 d-flex gap-5">
                    <input
                        type={"text"}
                        className="form-control form-control-md justify-content-right"
                        placeholder="Search"
                        name={"search"}
                        title={""}
                        value={this.state.search}
                        onChange = {(e)=>this.handlerSearch(e)}
                    />
                  </div>
                  :null} */}
                  </div>
                </div>
                {this.state.showData && dataTracking ?
                  <Fragment>
                    <div className="row">
                      <DataListRequest
                        {...this.props}
                        updateShow={this.updateShow}
                      ></DataListRequest>
                    </div>
                  </Fragment>
                  : this.state.showData && !dataTracking ?
                    <Fragment>
                      <div className="row text-center mt-5">
                        <h1>{i18n.t("No Data Avaliable")}</h1>
                      </div>
                    </Fragment>
                    : null

                }

                {this.state.showDataDetail?
                  <React.Fragment>
                    <div className={this.state.loadingData ? "table-loading" : ""}>
                      {!this.state.loadingData ? (
                        <Fragment>
                          <div className="row">
                            <DataListFull
                              {...this.props}
                              data={this.state.transactionList ?? ''}
                              backPage={this.backPage}
                            >

                            </DataListFull>
                          </div>
                        </Fragment>)
                        : (
                          <div className="table-loading-message">
                            <div className="spinner-border  text-primary text-center ms-3 clearfix"></div>
                            <div className="text-center">{i18n.t("Loading")}</div>
                          </div>
                        )}
                    </div>
                  </React.Fragment>
                  : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TrackingSales;
